<div id="pagetop">
  <div id="inner_pagetop" class="backtotop fix_center langen" [ngClass]="{'is-active': toTopButtonVisible}">
    <button type="button" (click)="scrollToTop()" class="scroll-top-button">TOP</button>
  </div>
</div>
